import React from 'react';

import styles from '../CardContent/styles/styles.module.scss';
import { getTrackActivity } from '../../../utils/track_helpers';
import CardDate from '../CardDate';
import CardLength from '../CardLength';
import CardName from '../CardName';
import StarRating from '../../shared/StarRating';
import Tag from '../../shared/Tag';
import UserImageLink from '../../shared/UserImageLink';

export default function TrackCardContent({ className, userImageClassNameOverride, context, track, namePaddingRight }) {
  return (
    <div className={[styles.content, className].join(' ')}>
      <CardName name={track.name} paddingRight={namePaddingRight} />
      <div className={styles.info}>
        <CardDate dateString={track.created_at} locale={context ? context.languageRegionCode : 'en-US'} />
      </div>
      <UserImageLink className={userImageClassNameOverride || styles.inlineBlock} context={context} user={track.user} />
      <div className={`${styles.inlineBlock} ${styles.marginTop}`}>
        <div className={styles.info}>
          <Tag className={styles.activityTag} title={getTrackActivity(track)} />
          <StarRating config={track.rating} />
        </div>
        <div className={styles.info}>
          <CardLength length={track.length || track.distance} displayMetric={context ? context.displayMetric : null} />
        </div>
      </div>
    </div>
  );
}
